import {
  ProductCategory,
  ProductCategoryWithProducts
} from '@dtx-company/flow-codegen/src/code/generated.types'
import { eventNames } from '../constants/printStore'
import { fireGtmEvent, fireHeapEvent, getDrawerAction } from '../helpers'

const {
  userClickedPrintStoreLink,
  userClickedPrintItYourselfDropdownOption,
  userClickedGetItPrintedDropdownOption,
  userClickedPrintDropdown,
  userSelectedProductQuantity,
  userEnteredInvalidZipcode,
  userEnteredEmptyZipcode,
  userEnteredValidZipcode,
  userClickedBackToPrintStoreButton,
  userClickedBackToCodeButton,
  userClickedContactUsButton,
  userClickedGetItPrintedDrawer,
  userClickedPrintItYourselfDrawer,
  userClickedPrintStoreProductCard,
  userClickedPrintStoreSurveyCard,
  userSelectedShippingOption,
  Print_Store_Cart_Selected_Handling_Option,
  userHoveredOverHowToUseSection,
  userHoveredOverStickerPhotosSection,
  Print_Store_PDP_Removed_Selected_Code,
  Print_Store_PDP_Selected_Product_Quantity,
  Print_Store_PDP_Clicked_Back_Button,
  Print_Store_PDP_Clicked_View_Cart_Button,
  Print_Store_PDP_Added_Item,
  userClickedPrintStoreHeroStickers,
  userClickedPrintStoreHeroBusinessCards,
  userClickedPrintStoreHeroTableTents,
  Print_Store_Homepage_Clicked_Print_Store_FAQs_Btn,
  userClickedPrintStoreUpsell,
  Flowcode_Store_Clicked_Bottom_Banner_Get_Flowtag_Btn,
  Flowcode_Store_Categories_Clicked_Category_Card,
  Flowcode_Store_Products_Clicked_See_All,
  PrintTemplates_Templates_Brand_Kit_Selected_Flowcode,
  PrintTemplates_Templates_Brand_Kit_Removed_Flowcode,
  PrintTemplates_Templates_Brand_Kit_Entered_CTA,
  PrintTemplates_Templates_Brand_Kit_Added_Logo,
  PrintTemplates_Templates_Brand_Kit_Removed_Logo,
  PrintTemplates_Templates_Brand_Kit_Selected_Primary_Color,
  PrintTemplates_Templates_Brand_Kit_Selected_Secondary_Color,
  PrintTemplates_Templates_Brand_Kit_Clicked_Update,
  PrintTemplates_TemplateEditor_clicked_downloadbutton,
  PrintTemplates_TemplateEditor_DownloadModal_clicked_download,
  PrintTemplates_TemplateEditor_DownloadModal_clicked_order,
  PrintTemplates_TemplateEditor_DownloadModal_clicked_email,
  PrintTemplates_TemplateEditor_DownloadModal_clicked_print,
  PrintTemplates_TemplateEditor_EmailModal_clicked_close,
  PrintTemplates_TemplateEditor_EmailModal_clicked_submit,
  PrintTemplates_Templates_Brand_Kit_Clicked_Create_Flowcode,
  PrintTemplates_Templates_Brand_Kit_Clicked_Select_Flowcode
} = eventNames

export const events = {
  userClickedPrintStoreLink(section: string): void {
    fireHeapEvent(userClickedPrintStoreLink, {
      section
    })
  },
  userClickedPrintItYourselfDropdownOption(): void {
    fireHeapEvent(userClickedPrintItYourselfDropdownOption)
  },
  userClickedGetItPrintedDropdownOption(): void {
    fireHeapEvent(userClickedGetItPrintedDropdownOption)
  },
  userClickedPrintDropdown(opened: boolean): void {
    fireHeapEvent(userClickedPrintDropdown, {
      action: getDrawerAction(opened)
    })
  },
  userClickedPrintStoreProductCard(productId: string, productStockStatus: string): void {
    fireHeapEvent(userClickedPrintStoreProductCard, { productId, productStockStatus })
    fireGtmEvent(userClickedPrintStoreProductCard)
  },
  userClickedPrintStoreSurveyCard(): void {
    fireHeapEvent(userClickedPrintStoreSurveyCard)
  },
  userSelectedProductQuantity(productId: string, quantity: number): void {
    fireHeapEvent(userSelectedProductQuantity, {
      productId,
      quantity
    })
  },
  userSelectedShippingOption(productId: string, shippingOptionId: string): void {
    fireHeapEvent(userSelectedShippingOption, { productId, shippingOptionId })
  },
  Print_Store_Cart_Selected_Handling_Option(handlingOptionId: string): void {
    fireHeapEvent(Print_Store_Cart_Selected_Handling_Option, { handlingOptionId })
  },
  userEnteredValidZipcode(): void {
    fireHeapEvent(userEnteredValidZipcode)
  },
  userEnteredInvalidZipcode(): void {
    fireHeapEvent(userEnteredInvalidZipcode)
  },
  userEnteredEmptyZipcode(): void {
    fireHeapEvent(userEnteredEmptyZipcode)
  },
  userClickedBackToPrintStoreButton(): void {
    fireHeapEvent(userClickedBackToPrintStoreButton)
  },
  userClickedBackToCodeButton(): void {
    fireHeapEvent(userClickedBackToCodeButton)
  },
  userClickedContactUsButton(section: string): void {
    fireHeapEvent(userClickedContactUsButton, { section })
  },
  userClickedGetItPrintedDrawer(opened: boolean): void {
    fireHeapEvent(userClickedGetItPrintedDrawer, {
      action: getDrawerAction(opened)
    })
  },
  userClickedPrintItYourselfDrawer(opened: boolean): void {
    fireHeapEvent(userClickedPrintItYourselfDrawer, {
      action: getDrawerAction(opened)
    })
  },
  userHoveredOverHowToUseSection(): void {
    fireHeapEvent(userHoveredOverHowToUseSection)
  },
  userHoveredOverStickerPhotosSection(): void {
    fireHeapEvent(userHoveredOverStickerPhotosSection)
  },

  Print_Store_PDP_Removed_Selected_Code(): void {
    fireHeapEvent(Print_Store_PDP_Removed_Selected_Code)
  },
  Print_Store_PDP_Selected_Product_Quantity(productId: string, quantity: number): void {
    fireHeapEvent(Print_Store_PDP_Selected_Product_Quantity, { productId, quantity })
  },
  Print_Store_PDP_Clicked_Back_Button(): void {
    fireHeapEvent(Print_Store_PDP_Clicked_Back_Button)
  },
  Print_Store_PDP_Clicked_View_Cart_Button(component?: string): void {
    fireHeapEvent(Print_Store_PDP_Clicked_View_Cart_Button, {
      component
    })
  },
  Print_Store_PDP_Added_Item(
    productId: string,
    batchId: string,
    templateId?: string,
    dhTemplateId?: string,
    dhProjectId?: string
  ): void {
    fireHeapEvent(Print_Store_PDP_Added_Item, {
      productId,
      batchId,
      templateId,
      dhTemplateId,
      dhProjectId
    })
  },
  userClickedPrintStoreHeroStickers(): void {
    fireHeapEvent(userClickedPrintStoreHeroStickers)
  },
  userClickedPrintStoreHeroBusinessCards(): void {
    fireHeapEvent(userClickedPrintStoreHeroBusinessCards)
  },
  userClickedPrintStoreHeroTableTents(): void {
    fireHeapEvent(userClickedPrintStoreHeroTableTents)
  },
  Print_Store_Homepage_Clicked_Print_Store_FAQs_Btn(): void {
    fireHeapEvent(Print_Store_Homepage_Clicked_Print_Store_FAQs_Btn)
  },

  userClickedPrintStoreUpsell(location: string): void {
    fireHeapEvent(userClickedPrintStoreUpsell, { location })
  },
  Flowcode_Store_Clicked_Bottom_Banner_Get_Flowtag_Btn(): void {
    fireHeapEvent(Flowcode_Store_Clicked_Bottom_Banner_Get_Flowtag_Btn)
  },
  Flowcode_Store_Categories_Clicked_Category_Card({
    id,
    name
  }: {
    id: ProductCategory['id']
    name: ProductCategory['name']
  }): void {
    fireHeapEvent(Flowcode_Store_Categories_Clicked_Category_Card, {
      categoryId: id,
      categoryName: name
    })
  },
  Flowcode_Store_Products_Clicked_See_All({
    categoryId,
    categoryName
  }: {
    categoryId: ProductCategoryWithProducts['id']
    categoryName: ProductCategoryWithProducts['name']
  }): void {
    fireHeapEvent(Flowcode_Store_Products_Clicked_See_All, {
      categoryId,
      categoryName
    })
  },
  PrintTemplates_Templates_Brand_Kit_Selected_Flowcode({
    flowcodeId
  }: {
    flowcodeId: string
  }): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Selected_Flowcode, { flowcodeId })
  },
  PrintTemplates_Templates_Brand_Kit_Removed_Flowcode({
    flowcodeId
  }: {
    flowcodeId?: string
  }): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Removed_Flowcode, { flowcodeId })
  },
  PrintTemplates_Templates_Brand_Kit_Entered_CTA({ cta }: { cta: string }): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Entered_CTA, { cta })
  },
  PrintTemplates_Templates_Brand_Kit_Added_Logo(): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Added_Logo)
  },
  PrintTemplates_Templates_Brand_Kit_Removed_Logo(): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Removed_Logo)
  },
  PrintTemplates_Templates_Brand_Kit_Selected_Primary_Color({ color }: { color: string }): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Selected_Primary_Color, { color })
  },
  PrintTemplates_Templates_Brand_Kit_Selected_Secondary_Color({ color }: { color: string }): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Selected_Secondary_Color, { color })
  },
  PrintTemplates_Templates_Brand_Kit_Clicked_Update(): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Clicked_Update)
  },
  PrintTemplates_TemplateEditor_clicked_downloadbutton(): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_clicked_downloadbutton)
  },
  PrintTemplates_TemplateEditor_DownloadModal_clicked_download(): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_DownloadModal_clicked_download)
  },
  PrintTemplates_TemplateEditor_DownloadModal_clicked_order(): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_DownloadModal_clicked_order)
  },
  PrintTemplates_TemplateEditor_DownloadModal_clicked_email(): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_DownloadModal_clicked_email)
  },
  PrintTemplates_TemplateEditor_DownloadModal_clicked_print(): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_DownloadModal_clicked_print)
  },
  PrintTemplates_TemplateEditor_EmailModal_clicked_close(): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_EmailModal_clicked_close)
  },
  PrintTemplates_TemplateEditor_EmailModal_clicked_submit(emails: string): void {
    fireHeapEvent(PrintTemplates_TemplateEditor_EmailModal_clicked_submit, { emails })
  },
  PrintTemplates_Templates_Brand_Kit_Clicked_Create_Flowcode(): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Clicked_Create_Flowcode)
  },
  PrintTemplates_Templates_Brand_Kit_Clicked_Select_Flowcode(): void {
    fireHeapEvent(PrintTemplates_Templates_Brand_Kit_Clicked_Select_Flowcode)
  }
}

export default events
